<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_main_section") }}</h4>
    </div>
    <!-- End:: Title -->

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cardname')"
            v-model.trim="data.name"
            required
            disabled
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.cardnumber')"
            v-model.trim="data.count"
            required
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cardprice')"
            v-model.trim="data.price"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cardvalue')"
            v-model.trim="data.value"
            required
            disabled
          />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.startDate')"
            v-model.trim="data.start_date"
            required
            disabled
          />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.endDate')"
            v-model.trim="data.end_date"
            required
            disabled
          />

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              disabled
              :label="
                data.status
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.status"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowCardCategory",

  data() {
    return {
      isWaitingRequest: false,

      data: {
        name: null,
        count: null,
        price: null,
        value: null,
        status: true,
        start_date: null,
        end_date: null,
      },
    };
  },

  computed: {
    paymentStatus() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.paid"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.unpaid"),
          value: 0,
        },
      ];
    },
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `card-categories/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.name = res.data.data?.CardCategories.name;
        this.data.count = res.data.data?.CardCategories.count_cards;
        this.data.value = res.data.data?.CardCategories.card_value;
        this.data.price = res.data.data?.CardCategories.card_price;
        this.data.start_date = res.data.data?.CardCategories.start_date;
        this.data.end_date = res.data.data?.CardCategories.end_date;

        this.data.active = res.data.data?.Section.is_active;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
